module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Readed-mail-005b44b2fd9dd622ad9b7329dd592e95.svg";